import React from 'react'

import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { dsColorNew } from "@palette"


export default function ratingColumn() {
	return {
		name: 'rating',
		label: 'Rating',
		options: {
			filter: false,
			customBodyRowRenderLite: value => {
				return <Box sx={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
					<Typography>{value}</Typography>
					<IconSeeker
						icon="star-sharp"
						sx={{
							mx: 0.7,
							color: dsColorNew.noteAmber,
							fontSize: 14
						}}
					/>
				</Box>
			},
		}
	}
}
